import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateUploadProcessDocument } from 'modules/documents/hooks/useUpdateUploadProcessDocument'

interface Props {
  documentId: string
  additionalSignersAccessIds: string[]
  onUpdatedFinished: () => void
}

interface ReturnType {
  onSubmit: () => void
  submitting: boolean
}

const useUpdateUploadProcessDocumentMutation = ({
  documentId,
  additionalSignersAccessIds,
  onUpdatedFinished,
}: Props): ReturnType => {
  const { updateUploadProcessDocument, loading } = useUpdateUploadProcessDocument()

  const onSubmit = async () => {
    const result = await updateUploadProcessDocument({ documentId, additionalSignersAccessIds })

    const handled = handleResult(result, (errors) => {
      const errorMessages = Object.values(errors)
      const errorMessage = errorMessages && errorMessages[0]

      if (errorMessage) app.setFlash({ type: 'wrong', message: errorMessage })
    })

    if (handled.success) {
      app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully') })
      await onUpdatedFinished()
    }

    return handled
  }

  return {
    onSubmit,
    submitting: loading,
  }
}

export default useUpdateUploadProcessDocumentMutation
